import { useState, useEffect } from 'react';
import LeftSidebarDesktop from './LeftSidebarDesktop';
import LeftSidebarMobile from './LeftSidebarMobile';

export default function LeftSidebar({ isOpen, onClose, ...props }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint for consistency
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return <LeftSidebarMobile isOpen={isOpen} onClose={onClose} {...props} />;
  }

  return <LeftSidebarDesktop {...props} />;
}

